import React from 'react';
import PropTypes from 'prop-types';
import { getStatusClass, getDuration } from '../../../utils/utils';
import styles from './Overview.css';

const Overview = ({ scannerName, connectionName, scannerRun }) => {
  return (
    <div className={styles.detailSection} data-test-id="scan-overview-section">
      <h2>Scan Overview</h2>
      <div className={styles.detailSectionContent}>
        <div className={styles.infoGrid} data-test-id="scanner-name">
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Name</span>
            <span>{scannerName}</span>
          </div>
          <div className={styles.infoItem} data-test-id="scanner-connection">
            <span className={styles.infoLabel}>Connection</span>
            <span>{connectionName}</span>
          </div>
          <div className={styles.infoItem} data-test-id="scanner-status">
            <span className={styles.infoLabel}>Status</span>
            <span
              className={`${styles.statusBadge} ${getStatusClass(scannerRun.status, styles)}`}
            >
              {scannerRun?.status || '-'}
            </span>
          </div>
          <div className={styles.infoItem} data-test-id="scanner-duration">
            <span className={styles.infoLabel}>Duration</span>
            <span data-test-id="scanner-duration">
              {getDuration(scannerRun.startedAt, scannerRun.endedAt)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

Overview.propTypes = {
  scannerName: PropTypes.string,
  connectionName: PropTypes.string,
  scannerRun: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    startedAt: PropTypes.string,
    endedAt: PropTypes.string,
    createdAt: PropTypes.string,
    summary: PropTypes.shape({
      added: PropTypes.number,
      updated: PropTypes.number,
      removed: PropTypes.number,
      unchanged: PropTypes.number,
      issuesFound: PropTypes.arrayOf(PropTypes.string)
    })
  })
};

export default Overview;
